import type { FC } from "react"

interface IconProps {
  width?: number
  fill?: string
  height?: number
}

export const AvatarPlaceholderIcon: FC<IconProps> = (props) => (
  <svg
    fill="none"
    height={24}
    viewBox="0 0 24 24"
    width={24}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="#252934" opacity={0.3}>
      <path d="M19 20.537c-.173-1.488-1.223-3.392-2.265-4.437-.127-.126-.333-.14-.447 0-2.094 2.567-5.909 3.713-8.49.416-.16-.204-.456-.246-.641-.073-.873.813-1.243 3.096-1.14 3.86.026.208.092.38.279.388 2.506.117 6.02.072 8.88.26.842-.096 3.56.363 3.824-.412z" />
      <path d="M10.071 16.549c4.024 2.161 8.364-3.927 8.095-8.023.092-.571-.393-.94-.875-1.286-.169-.257-.668-.69-.558-.94.51.014 1.112.457 1.627.655.958.272.653-1.132.287-1.594-.595-.794-1.146-1.94-2.213-2.223-.747-.04-1.4.132-1.079.964-.163.758-.794-.421-.444-.855-9.363-2.074-11.96 9.48-4.838 13.304zm6.516-3.717c.006-.021.018-.038.028-.059q.036 0 .029.04c-.004.019-.01.045-.027.054-.02.012-.039-.009-.03-.037zm-2.266 1.837c.17-.17.287-.378.47-.538.074-.064.167-.11.27-.05.107.06.089.165.04.233-.181.245-.267.579-.707.592-.13.004-.183.095-.236.219a.52.52 0 0 1 .165-.456z" />
      <path d="M6.11 5.484C6.331 4.333 8.18 3.596 7.985 3 6.717 2.987 5.236 4.883 5 6.488c.221 1.444.827-.581 1.11-1.004" />
    </g>
  </svg>
)
